import { Button, type ButtonProps, type ModalProps } from "@mantine/core"
import { useEditModal } from "./ModalBase"

export function ModalButton({
  label,
  variant = "filled",
  leftSection,
  ...props
}: Partial<ModalProps> & Pick<ButtonProps, "leftSection" | "variant"> & { label?: string }) {
  const { open } = useEditModal({ size: "lg" })
  return (
    <Button variant={variant} color="gray" leftSection={leftSection} onClick={() => open(props)}>
      {label || props.title}
    </Button>
  )
}
